import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { BookOpen } from "lucide-react";

export const WaitlistConfirmModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return createPortal(
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{ zIndex: 99999 }}
        data-testid="waitlist-confirm-modal"
      >
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/80" onClick={onClose} />

        {/* Modal */}
        <motion.div
          initial={{ opacity: 0, scale: 0.92, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.92, y: 20 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="relative w-full max-w-md rounded-3xl bg-warm-bone p-8 sm:p-10 shadow-2xl"
        >
          {/* Decorative gradient bar */}
          <div className="absolute top-0 left-8 right-8 h-1 rounded-full bg-gradient-to-r from-brand-peach to-brand-lavender" />

          <h2
            className="font-heading text-3xl sm:text-4xl text-text-dark mt-2 mb-4"
            data-testid="waitlist-confirm-headline"
          >
            You're In.
          </h2>

          <p className="text-text-dark/70 text-base leading-relaxed mb-8">
            Welcome to the Become community. While you wait, our blog is the best place to stay connected: real insights on transformation, career change, and navigating what comes next. We'll see you there.
          </p>

          <div className="space-y-3">
            <Button
              onClick={() => { onClose(); navigate("/blog"); }}
              className="w-full h-12 rounded-full bg-gradient-to-r from-brand-peach to-brand-lavender text-deep-violet font-semibold hover:shadow-[0_0_30px_rgba(245,168,130,0.5)] hover:-translate-y-0.5 transition-all duration-300"
              data-testid="waitlist-confirm-blog-btn"
            >
              <BookOpen className="w-5 h-5 mr-2" />
              Take Me to the Blog
            </Button>

            <button
              onClick={onClose}
              className="w-full py-3 text-sm text-text-dark/50 hover:text-text-dark/80 transition-colors"
              data-testid="waitlist-confirm-dismiss-btn"
            >
              I'll check it out later.
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};
